import { ErrorMessage, ErrorType } from "../../types/errorType";
import { ApiErrorResponse } from "../../types/apiErrorResponseType";

/**
 * Extracts error information from an API error response.
 *
 * @param error - The error object from the API response.
 * @returns An ErrorType object containing statusCode, title, and a list of error messages.
 */
export const ExtractErrorInfo = (error: ApiErrorResponse): ErrorType => {
  let statusCode = error.response?.status || 500;
  let title = error.response?.data?.title || "Request failed";
  const responses = error.response?.data?.responses || {};

  let messages: ErrorMessage[] = [];

  if (Object.keys(responses).length > 0) {
    // Iterate over each key in the responses object and map the responses to ErrorMessage objects.
    messages = Object.keys(responses).flatMap((key) => {
      return responses[key].map((response) => ({
        code: response.code || "ERR_UNKNOWN",
        message: `${key}: ${response.message || "Unknown error"}`,
      }));
    });
  } else {
    // If the responses object is empty, add a default error message.
    messages.push({
      code: "DEFAULT_ERROR",
      message: error.message || "Unknown error occurred",
    });
    // Handle specific status codes
    if (statusCode === 404) {
      title = "Not found";
    } else {
      statusCode = error.statusCode || 500;
      title = error.title || "Internal Server Error";
    }
  }

  return { statusCode, title, messages };
};
